<template>
  <b-card>
    <BulksModal user-type="user" />
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="usersLoading"
    >
      <div class="d-flex align-items-center mb-1">
        <b-button
          v-if="$can('write', 'transaction-bulks') && isJordanianAdmin()"
          variant="success"
          class="mr-2"
          @click="$bvModal.show('transaction-bulks')"
        >
          Transactions Bulks
        </b-button>
        <BulkClearInflightModal
          v-if="$can('write', 'trips')"
          entity-type="users"
        />
      </div>
      <b-form @submit.prevent="fetchUsers">
        <b-row class="mb-2">
          <b-col
            md="2"
          >
            <b-form-input
              v-model="queryParams.external_id"
              placeholder="External Id"
              clearable
            />
          </b-col>
          <b-col md="2">
            <v-select
              v-model="queryParams.activeState"
              placeholder="Search by status"
              label="label"
              :options="statusOptions"
              :reduce="(option) => option.value"
            />
          </b-col>
          <b-col md="2">
            <b-form-input
              v-model="queryParams.text"
              type="number"
              placeholder="Phone"
              clearable
            />
          </b-col>
          <b-col md="2">
            <b-form-input
              v-model="queryParams.device_id"
              type="text"
              placeholder="Device Id"
              clearable
            />
          </b-col>
          <b-col md="2">
            <b-button
              variant="primary"
              type="submit"
              :disabled="!canSearch"
            >
              Search
            </b-button>
            <b-button
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="fetchUsers"
            >
              <feather-icon
                icon="RefreshCwIcon"
              />
            </b-button>
          </b-col>
          <b-col
            md="1"
            class="d-flex align-items-center"
          >
            <h6 class="mb-0">
              Total:
            </h6>
            <span> {{ totalUsers }}</span>
          </b-col>
        </b-row>
      </b-form>
      <b-table
        responsive
        :items="users"
        :fields="tableColumns"
        show-empty
        empty-text="In order to get results you need to search for specific data."
        hover
        striped
        @row-clicked="$router.push({ path :`/users/${$event.id}`,query :{ externalId: $event.externalId } })"
      >
        <template #cell(user)="data">
          {{ data.item.firstName + ' ' + data.item.lastName }}
        </template>

        <template #cell(gender)="data">
          {{ data.item.gender == 'FEMALE' ? 'Female' : 'Male' }}
        </template>

        <template #cell(activeState)="data">
          <b-badge
            pill
            :variant="`light-${data.item.activeState == 'ACTIVE' ? 'success' : 'danger'}`"
            class="text-capitalize"
          >
            {{ data.item.activeState }}
          </b-badge>
        </template>
      </b-table>
      <base-pagination
        v-model="queryParams.page"
        :total="totalUsers"
        @new-per-page="queryParams.perPage = $event"
      />
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BOverlay, BTable, BBadge, BRow, BCol, BCard, BFormInput, BButton, BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import storeModule from '../store'
import useUsersList from '../hooks/useUsersList'
import BasePagination from '@/UI/BasePagination.vue'
import BulksModal from '@/views/billing/transaction-bulks/components/BulksModal.vue'
import { isJordanianAdmin } from '@/utils/validate-admin-country'
import BulkClearInflightModal from '@/views/driver-user-shared/bulk-clear-inflight/BulkClearInflightModal.vue'

export default {
  components: {
    BulkClearInflightModal,
    BOverlay,
    BTable,
    BBadge,
    BCol,
    BRow,
    BCard,
    BFormInput,
    BButton,
    vSelect,
    BasePagination,
    BForm,
    BulksModal,

  },
  setup(_, ctx) {
    useRegisterStoreModule('users', storeModule)

    return {
      isJordanianAdmin,
      ...useUsersList(ctx),
    }
  },
}
</script>

<style>

</style>
